import React, { useEffect, useState, useCallback } from "react";
import cn from "classnames";
import Master from "screen/Master";
import styles from "./Fota.module.scss";
import { Link, useHistory } from "react-router-dom";
import NewTableList from "components/common/NewTableList";
import FirmwareStore from "./FirmwareStores";
import FirmwareUpgrade from "./FirmwareUpgrade";
import { getRequest as getRequestForPrice } from "services/axiosBaseClient";
// import ServiceRequestViewMaster from "components/common/ServiceRequestViewTableMaster";
import NewTableAndSearchMasterFilter from "components/common/NewTableAndSearchMasterFilter";

var tempTigger;
var tabTemp = "inactive";
function FotaPage(props) {
  const history = useHistory();
  const [text, setText] = useState("Active");
  const [table, setTable] = useState(
    props.location?.state?.table ? props.location.state.table : 0
  );

  useEffect(() => {
    tabTemp = "inactive";
    tempTigger = !history?.location?.compomentRenderType
      ? "init"
      : history?.location?.compomentRenderType === "amhitted"
      ? "amhitted"
      : history?.location?.compomentRenderType === "view"
      ? "view"
      : "amhitted";
  }, [
    history?.location?.state?.compomentRenderType ||
      props.history?.location?.state?.compomentRenderType,
  ]);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  useEffect(() => {
    localStorage.setItem("activeTabCount", "zoneAsset");
  }, []);

  return (
    <>
      <div
        id="Fota_TotalCount_Container"
        className={cn(styles.flex2, styles.flex2_layout)}
      >
        <h2
          id="Fota_Heading"
          className={cn(styles.medium_title, styles.medium_title_layout)}
        >
          {"Firmware OTA "}
        </h2>
        {table === 0 && (
          <>
            <div className={cn(styles.flex2_spacer3)} />
            <div className={cn(styles.group, styles.group_layout)}>
              <div className={cn(styles.block5, styles.block5_layout)}>
                {/* <Link to="/Fota/uploadFirmware"> */}
                  <div
                    id="Fota_Upload_block"
                    className={cn(styles.flex3, styles.flex3_layout)}
                  >
                    <div
                      id="Fota_Upload_layout"
                      className={cn(styles.block7, styles.block7_layout)}
                    >
                      <div id="Fota_Upload" className={cn(styles.block7_item)}>
                        <img
                          id="Fota_Upload_img"
                          src={require("assets/ic_arrow_up.svg").default}
                          alt="Rectangle 16663"
                        />
                      </div>

                      <div
                        id="Fota_Upload_Title"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout,
                          styles.pdr10
                        )}
                      >
                        {"Upload Firmware"}
                      </div>
                    </div>
                  </div>
                {/* </Link> */}
              </div>
            </div>
          </>
        )}
      </div>
      <div
        id="FOTA_Subtitle_text_block"
        style={{ display: "flex", justifyContent: "space-between" }}
        className={cn(styles.flex8, styles.flex51_layout)}
      >
        <div id="FOTA_Subtitle_text_layout" className={cn(styles.flex6_layout)}>
          <div id="FOTA_Subtitle_text" className={cn(styles.flex21_item)}>
            <h3
              id="FOTA_Subtitle_Heading_Admin"
              className={
                table === 0
                  ? cn(styles.subtitle11, styles.subtitle11_layout)
                  : cn(styles.subtitle41, styles.subtitle1A_layout)
              }
              onClick={() => {
                setTable(0);
                tabTemp = "active";
                localStorage.setItem("lastTableSearch", "");
              }}
              style={{ cursor: "pointer" }}
            >
              {"Firmware Stores"}
            </h3>
          </div>
          <div className={cn(styles.flex5_spacer)} />
          <div id="FOTA_Subtitle_text1" className={cn(styles.flex2_item)}>
            <h3
              id="FOTA_Subtitle_Heading_Operator"
              className={
                table === 1
                  ? cn(styles.subtitle11, styles.subtitle11_layout)
                  : cn(styles.subtitle2, styles.subtitle2_layout)
              }
              onClick={() => {
                setTable(1);
                tabTemp = "active";
                localStorage.setItem("lastTableSearch", "");
              }}
              style={{ cursor: "pointer" }}
            >
              {"Swap Station Firmware Upgrade"}
            </h3>
          </div>
          <div className={cn(styles.flex5_spacer)} />
        </div>
      </div>
      <hr style={{ backgroundColor: "#E0E0E0" }} />
      <div
      // className={cn(styles.flex4, styles.flex4_layout)}
      >
        {/* <div className={cn(styles.flex4_spacer)} /> */}
        {table === 0 ? (
          <FirmwareStore
            tigger={tempTigger}
            tabTemp={tabTemp}
            headerFilter={props.headerFilter}
          />
        ) : table === 1 ? (
          <FirmwareUpgrade
            tigger={tempTigger}
            tabTemp={tabTemp}
            headerFilter={props.headerFilter}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
}

export default function FotaMain(props) {
  const [headerFilter, setHeaderFilter] = useState(true);
  return (
    <>
      <Master
        opts={props}
        screen={FotaPage}
        showStatus={false}
        headerFilter={headerFilter}
        setHeaderFilter={setHeaderFilter}
      />
    </>
  );
}
FotaMain.inStorybook = true;

FotaPage.inStorybook = true;
